import { Grid } from 'semantic-ui-react';
import styled from 'styled-components'


export const GridWrapper = styled(Grid)`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
